import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'Do I need a driving licence?',
      answer:
        "No! That's the whole point. Kyle Drive is designed for people aged 10+ who don't yet have a licence. Our experienced driver handles guidance and controls, walking you through everything safely.",
    },
    {
      question: 'What cars do you use?',
      answer:
        "We use well-maintained cars that are suitable for learner drivers. They're modern, reliable, and easy to handle - perfect for first-time drivers.",
    },
    {
      question: 'Is it safe?',
      answer:
        'Absolutely. Sessions take place in a private, traffic-free car park. An experienced driver is in the car at all times, providing constant supervision and guidance. Safety is our number one priority.',
    },
    {
      question: 'What should I wear?',
      answer:
        'Comfortable clothing and flat shoes are all you need. Trainers are ideal - avoid high heels, flip-flops, or very thick-soled boots as they can make it harder to feel the pedals.',
    },
    {
      question: 'Can parents/guardians watch?',
      answer:
        "Yes! There's space for family and friends to watch the session. It's a great spectator experience too - especially for proud parents!",
    },
    {
      question: "What's the minimum age?",
      answer:
        "You must be at least 10 years old on the day of your session. There's no upper age limit - adults are welcome too if they fancy a go!",
    },
    {
      question: 'Can I book as a gift?',
      answer:
        "Absolutely - it makes a brilliant birthday or Christmas gift! Book online and you'll receive a confirmation with all the details. Gift vouchers are coming soon.",
    },
    {
      question: 'What if the weather is bad?',
      answer:
        "Weather is not an issue! Kyle Rise is a multi-storey car park, so all sessions are sheltered from rain, wind, and snow. You'll be dry and comfortable whatever the Scottish weather brings.",
    },
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[hsl(210,100%,12%)] mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-gradient-to-br from-white to-blue-50 rounded-2xl border-2 border-gray-200 px-6 hover:border-[hsl(210,100%,45%)] transition-all shadow-sm"
            >
              <AccordionTrigger className="text-left text-[hsl(210,100%,12%)] hover:text-[hsl(210,100%,45%)] transition-colors py-6 font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;